import React from 'react';
import { ToastProvider } from '@fortress-technology-solutions/fortress-component-library/contexts';
import { SectionsProgressProvider } from 'contexts/SectionsProgressContext';
import { FormStateProvider } from 'contexts/FormStateContext';
import { HouseholdMembersProvider } from 'contexts/HouseholdMembersContext';
import { AffordaPortalDetailsProvider } from 'contexts/AffordaPortalDetailsContext';

const Providers = ({ children }) => {
  return (
    <ToastProvider>
      <AffordaPortalDetailsProvider>
        <HouseholdMembersProvider>
          <SectionsProgressProvider>
            <FormStateProvider>{children}</FormStateProvider>
          </SectionsProgressProvider>
        </HouseholdMembersProvider>
      </AffordaPortalDetailsProvider>
    </ToastProvider>
  );
};

export default Providers;
